import { useMemo } from 'react'
import type { CalculatorEntry } from '@/types/calculator'

export function useSearch(calculators: CalculatorEntry[], query: string): CalculatorEntry[] {
  return useMemo(() => {
    const q = query.toLowerCase().trim()
    if (!q) return calculators
    return calculators.filter(c => {
      return (
        c.name.toLowerCase().includes(q) ||
        c.description.toLowerCase().includes(q) ||
        c.category.toLowerCase().includes(q) ||
        c.keywords.some(k => k.toLowerCase().includes(q))
      )
    })
  }, [calculators, query])
}
